import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-pricing',
	templateUrl: './pricing.component.html',
	styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
	@Input() campaignId: number;
	form: FormGroup;
	loading: boolean;
	prices: any[];
	editMode: boolean;
	selectedPrice: any;

	constructor(
		private modalService: NgbModal,
		private fb: FormBuilder,
		private campaignSrv: CampaignService,
		public utils: UtilsService
	) {
		this.loading = false;
		this.editMode = false;
		this.selectedPrice = {};
	}

	ngOnInit() {
		this.form = this.fb.group({
			description: ['', Validators.required],
			price: ['', [Validators.required, Validators.pattern('^[0-9]*\.?[0-9]+$')]],
			id: ['']
		});
		this.getPrices();

	}

	open(content: TemplateRef<any>, price = null) {
		if(price != null){
			this.editMode = true;
			this.selectedPrice = price;
			this.form.patchValue({
				description: price.description,
				price: price.price,
				id: price.id
			});
		}

		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info("Cerrado en result");
			},
			(reason) => {
				this.selectedPrice = {};
				this.editMode = false;
				this.form.reset();
			}
		);
	}

	getPrices(){
		this.campaignSrv.getCampaignPrices(this.campaignId).subscribe((data: any)=>{
			this.prices = data.body;
		});
	}

	onSubmit(edit = false) {
		this.loading = true;
		if (this.form.valid) {
			const formValues = this.form.value;

			const data = {
				description: formValues.description,
				price: formValues.price,
				campaignId: this.campaignId,
				id: formValues.id
			}

			let callAPI = this.campaignSrv.addPrice(data);
			let text = 'Price added correctly'
			if(edit){
				callAPI = this.campaignSrv.editPrice(data);
				text = 'Price edited correctly'
			}

			callAPI.subscribe(data => {
				this.form.reset();
				this.editMode = false;
				this.modalService.dismissAll();
				this.getPrices();
				Swal.fire({
					text,
					showCancelButton: false,
					confirmButtonText: 'Ok',
					icon: 'success'
				});
				this.loading = false;
			});

		} else {
			this.form.markAllAsTouched(); // Marcar todos los campos como "tocados" para mostrar errores
		}
	}

	deletePrice(){
		this.loading = true;
		this.campaignSrv.deletePrice(this.selectedPrice.id).subscribe(data=>{
			this.loading = false;
			Swal.fire({
				text: 'Price deleted correctly',
				showCancelButton: false,
				confirmButtonText: 'Ok',
				icon: 'success'
			});
			this.getPrices();
			this.form.reset();
			this.modalService.dismissAll();
		});
	}

	showDeleteBtn(){
		if(this.editMode){
			if(this.selectedPrice.description != 'Lead Cost' &&  this.selectedPrice.description != 'Reschedule Cost' && this.selectedPrice.description != 'Replacement Cost'){
				return true;
			}
			return false;
		}
		return false;
	}



}
